import React, { useState } from "react";
import Button, { ButtonThemes } from "../../../../ui-components/button/button";
import { ActivityLogEntry } from "../../../../app/data/invoice-factoring/models";
import { formatDateTime, formatJson } from "../constants";

export interface ActivityListProps {
  entries?: ActivityLogEntry[];
  isLoading?: boolean;
  emptyText?: string;
}

const ActivityRow: React.FC<{ entry: ActivityLogEntry }> = ({ entry }) => {
  const [open, setOpen] = useState(false);
  const hasMetadata = !!entry.metadata && Object.keys(entry.metadata).length > 0;

  return (
    <li className="xgs-invoice-factoring__activity-item">
      <div className="xgs-invoice-factoring__activity-head">
        <span className="xgs-invoice-factoring__activity-time">{formatDateTime(entry.createdAt)}</span>
        <span className="xgs-invoice-factoring__activity-actor">{entry.actorEmail}</span>
        <span className="xgs-invoice-factoring__activity-action">{entry.action}</span>
      </div>
      <div className="xgs-invoice-factoring__activity-message">{entry.message}</div>
      {hasMetadata && (
        <>
          <Button theme={ButtonThemes.transparent} type="button" onClick={() => setOpen(!open)}>
            {open ? "Hide details" : "Show details"}
          </Button>
          {open && <pre className="xgs-invoice-factoring__json">{formatJson(entry.metadata)}</pre>}
        </>
      )}
    </li>
  );
};

const ActivityList: React.FC<ActivityListProps> = ({ entries, isLoading, emptyText = "No activity yet." }) => {
  if (isLoading) return <div className="xgs-invoice-factoring__muted">Loading activity…</div>;
  if (!entries?.length) return <div className="xgs-invoice-factoring__muted">{emptyText}</div>;

  return (
    <ul className="xgs-invoice-factoring__activity">
      {entries.map((entry) => (
        <ActivityRow key={entry.id} entry={entry} />
      ))}
    </ul>
  );
};

export default ActivityList;
